import { Tab, TabProps, Tabs, TabsOwnProps, TabsProps } from '@mui/material';
import { a11yProps } from '@shared/utils';

/* Use the same id as TabPanel */
interface Props {
  id: string;
  tabs: Array<Pick<TabProps, 'label' | 'value' | 'icon'>>;
  tabSize?: 'small' | 'medium';
  currentTab: string | number;
  onChange: TabsProps['onChange'];
  variant?: TabsOwnProps['variant'];
}

export default function ChipTabs({
  id,
  tabs,
  tabSize = 'medium',
  currentTab,
  variant,
  onChange,
}: Props) {
  return (
    <Tabs value={currentTab} onChange={onChange} variant={variant}>
      {tabs.map(({ label, value, icon }, index) => (
        <Tab
          key={`${id}-${value || index}`}
          className={tabSize === 'small' ? 'tab--small' : undefined}
          label={label}
          value={value || index}
          icon={icon}
          {...a11yProps(id, value || index)}
        />
      ))}
    </Tabs>
  );
}
